// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2rrnn","header":"ReportDetails_header__yYlgC","title":"ReportDetails_title__pH1zi","left":"ReportDetails_left__1ubzf"};